import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Card from "components/card";
import StoreAction from "./components/StoreAction";
import StoreModal from "./components/StoreModal";
import SearchBar from "components/search/SearchBar";
import CategoryFilter from "./components/CategoryFilter";
import VoucherGrid from "./components/VoucherGrid";
import { vouchers } from "./components/Vouchers";
import { 
	getCategoryList, 
	getMerchantList, 
    getMyActiveCart,
} from "../../../redux/hyvidstore/hyvidStoreState";
import { displayIcon } from "variables/icons";
import { NumberFormatter } from "utils/index";

const HyvidStore = () => {
    const [category, setCategory] = useState("all");
    const [searchTerm, setSearchTerm] = useState("");
    const [cartItems, setCartItems] = useState([]);

    const dispatch = useDispatch();
          
    const categoryList = useSelector((state) => state.hyvidStore.categoryList.items);
    const merchantList = useSelector((state) => state.hyvidStore.merchantList.items);
    const myActiveCart = useSelector((state) => state.hyvidStore.cartDetails.data);
    const myRewardSummary = useSelector((state) => state.employeeReward.myRewardSummary);

    useEffect(() => {
        dispatch(getCategoryList());
        dispatch(getMyActiveCart());
    },[dispatch]);

    useEffect(() => {
        dispatch(getMerchantList());
    },[dispatch, categoryList]);

    const voucherGridRef = useRef(null);

    const handleSearch = ({ keyword }) => {
        setSearchTerm(keyword || "");
    };

    const handleAddToCart = (voucher) => {
        setCartItems(prev => {
        const existing = prev.find(item => item.voucher.value === voucher.value);
            if (existing) {
                return prev.map(item =>
                item.voucher.value === voucher.value
                    ? { ...item, quantity: item.quantity + 1 }
                    : item
                );
            } else {
                return [...prev, { voucher, quantity: 1 }];
            }
        });
    };

    const handleRemoveFromCart = (voucher) => {
        setCartItems(prev => prev.filter(item => item.voucher.value !== voucher.value));
    };

    const handleUpdateQuantity = (voucher, delta) => {
        setCartItems(prev => prev
        .map(item =>
            item.voucher.value === voucher.value
            ? { ...item, quantity: Math.max(1, item.quantity + delta) }
            : item
        )
        .filter(item => item.quantity > 0)
        );
    };

    const filteredVouchers = vouchers.filter((v) => {
        const matchesCategory = category === "all" || v.category === category;
        const matchesSearch =
        v.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        v.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
        v.category.toLowerCase().includes(searchTerm.toLowerCase());
        return matchesCategory && matchesSearch;
    });

    const scrollToVouchers = () => {
        if (voucherGridRef.current) {
            voucherGridRef.current.scrollIntoView({ behavior: "smooth" });
        }
    };

    return (
        <Card className="space-y-6">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                <div>
                    <h1 className="text-[28px] font-bold label-gradient emerald flex items-center gap-3">
                        { displayIcon("Gift","w-8 h-8 text-emerald-600")}
                        HyvidStore
                    </h1>
                    <p className="text-[14px] mt-1 muted-text">
                        Redeem amazing gift vouchers with your Hyvid Points
                    </p>
                </div>
                <div className="flex items-center gap-3">
                    <div className="text-slate-900 flex flex-col gap-6 rounded-xl border-2 border-emerald-200 bg-gradient-to-r from-emerald-50 to-purple-50 dark:from-emerald-900 dark:to-purple-900 dark:border-emerald-700 ">
                        <div className="pb-6 p-3 flex items-center gap-2">
                            { displayIcon("Sparkles","w-5 h-5 text-emerald-600 dark:text-emerald-500")}
                            <div>
                                <p className="text-[10px] muted-text">
                                    Your Points
                                </p>
                                <p className="font-bold text-emerald-600 dark:text-emerald-500">
                                    {NumberFormatter(myRewardSummary?.data?.balance ?? 0, 0)}
                                </p>
                            </div>
                        </div>
                    </div>
                    <StoreAction cartItems={myActiveCart?.cart_items} setCartItems={setCartItems}>
                        {/* <StoreModal 
                            cartItems={myActiveCart?.cart_items} 
                            setCartItems={setCartItems}
                            onRemove={handleRemoveFromCart}
                            onUpdateQuantity={handleUpdateQuantity}
                        /> */}
                    </StoreAction>
                </div>
            </div>
            <div className="flex flex-col sm:flex-row gap-4">
                <SearchBar
                    placeholder="Search vouchers by name, brand, or category..."
                    searchHandler={handleSearch}
                />
            </div>
            <CategoryFilter
                categories={categoryList}
                value={category}
                onChange={setCategory}
                onBrowseAll={scrollToVouchers}
            />
            <div ref={voucherGridRef}>
                <VoucherGrid 
                    vouchers={merchantList} 
                    onAdd={handleAddToCart}
                />
            </div>
        </Card>
    )
};
export default HyvidStore;